import { useEffect, useState } from "react";
import { Save, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/appApi";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";

export default function OrgTopics() {
  const [units, setUnits] = useState([]);
  const [topics, setTopics] = useState([]);
  const [newTopic, setNewTopic] = useState("");

  const load = () => {
    api.get("/public/units").then((r) => setUnits(r.data));
    api.get("/public/topics").then((r) => setTopics(r.data));
  };
  useEffect(() => { load(); }, []);

  const saveUnit = async (u) => {
    try { await api.put(`/units/${u.slug}`, { ringkasan: u.ringkasan, pasal: u.pasal, head_official: u.head_official || "", full_name: u.full_name }); toast.success("Unit disimpan"); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  const addTopic = async () => { if (!newTopic) return; try { await api.post("/topics", { name: newTopic }); setNewTopic(""); toast.success("Topik ditambah"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Gagal"); } };
  const delTopic = async (slug) => { try { await api.delete(`/topics/${slug}`); load(); } catch { toast.error("Gagal"); } };

  const setUnit = (i, k, v) => setUnits((arr) => arr.map((u, idx) => idx === i ? { ...u, [k]: v } : u));

  return (
    <div>
      <h1 className="font-serif text-3xl font-extrabold text-dlh-green mb-6">Organisasi & Topik</h1>
      <Tabs defaultValue="units">
        <TabsList className="mb-6"><TabsTrigger value="units">Sekretariat & Bidang</TabsTrigger><TabsTrigger value="topics">Topik</TabsTrigger></TabsList>

        <TabsContent value="units">
          <p className="text-sm text-gray-500 mb-4">Perbarui ringkasan tupoksi berdasarkan dokumen resmi yang telah diverifikasi. Nama pejabat hanya ditampilkan setelah diisi.</p>
          <div className="space-y-4">
            {units.map((u, i) => (
              <div key={u.slug} className="bg-white rounded-xl border border-gray-200 p-5" data-testid={`unit-edit-${u.slug}`}>
                <h3 className="font-serif font-bold text-dlh-green leading-snug">{u.name}</h3>
                <p className="text-xs text-gray-400 mb-3">{u.is_support ? "Unit pendukung" : "Bidang teknis"} · {u.pasal}</p>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Ringkasan Tugas & Fungsi</label>
                <textarea value={u.ringkasan} onChange={(e) => setUnit(i, "ringkasan", e.target.value)} rows={3} className="w-full border rounded-lg px-3 py-2 text-sm mb-3" />
                <div className="grid sm:grid-cols-2 gap-3 mb-3">
                  <div><label className="block text-xs font-semibold text-gray-600 mb-1">Dasar Rujukan</label><input value={u.pasal || ""} onChange={(e) => setUnit(i, "pasal", e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm" /></div>
                  <div><label className="block text-xs font-semibold text-gray-600 mb-1">Nama Pejabat (opsional, terverifikasi)</label><input value={u.head_official || ""} onChange={(e) => setUnit(i, "head_official", e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm" /></div>
                </div>
                <Button onClick={() => saveUnit(u)} size="sm" className="bg-dlh-green hover:bg-dlh-greenDark"><Save className="h-4 w-4 mr-1" /> Simpan</Button>
              </div>
            ))}
          </div>
        </TabsContent>

        <TabsContent value="topics">
          <div className="flex gap-2 mb-4 max-w-md">
            <input value={newTopic} onChange={(e) => setNewTopic(e.target.value)} placeholder="Nama topik baru" className="flex-1 border rounded-lg px-3 py-2" data-testid="new-topic-input" />
            <Button onClick={addTopic} className="bg-dlh-green hover:bg-dlh-greenDark"><Plus className="h-4 w-4" /></Button>
          </div>
          <div className="flex flex-wrap gap-2">
            {topics.map((t) => (
              <span key={t.slug} className="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-full pl-4 pr-2 py-1.5 text-sm">
                {t.name}
                <button onClick={() => delTopic(t.slug)} className="text-gray-400 hover:text-red-500"><Trash2 className="h-3.5 w-3.5" /></button>
              </span>
            ))}
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}
